import React, { Component } from 'react';
import LogoAndTitle from '../../Layout/components/LogoAndTitle';
import { Paper, Typography, Button, Grid } from '@material-ui/core';
import { withRouter, RouteComponentProps } from 'react-router';

class NotFoundView extends Component<RouteComponentProps> {
    render() {
        return (
            <div>
                <LogoAndTitle title="Not found!"></LogoAndTitle>
                <Paper style={{ padding: '15px' }}>
                    <Grid container>
                        <Grid item sm={12}>
                            <Typography style={{padding:'15px'}} variant="h2">Resource you are looking for couldn't be found.</Typography>
                        </Grid>
                        <Grid item sm={12} style={{textAlign:'center'}}>
                            <Button onClick={() => this.props.history.push('/')} variant="contained" color="primary">Go to Home</Button>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        );
    }
}

export default withRouter(NotFoundView);